import { render, staticRenderFns } from "./seeRecognitionsPersonType.vue?vue&type=template&id=4f6ac006"
import script from "./seeRecognitionsPersonType.vue?vue&type=script&lang=js"
export * from "./seeRecognitionsPersonType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports